<template>
  <div>
    <settings-card :config="config">
      <el-button
        type="text"
        @click="payApply">去设置</el-button>
    </settings-card>
    <gifts-card-modal
      ref="gifts"
      :applyInfo="userDetail" />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import SettingsCard from './settings-card.vue'
import GiftsCardModal from './gifts-card-modal.vue'
export default {
  name: 'GiftsCard',
  components: {
    SettingsCard,
    GiftsCardModal
  },
  props: {
    config: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      userDetail: state => state.account.userDetail
    })
  },
  methods: {
    payApply() {
      this.$refs.gifts.getsetting()
    }
  }
}
</script>
